class CustomFooter extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `
            <!-- Footer -->
    <footer class="site-footer">
      <div class="footer-container">
        <!-- Column 1: Organization Credentials & Legal -->
        <div class="footer-col credentials-col">
          <h3>Por Un Mundo Mejor (P1MM)</h3>
          <p class="credential-id" data-i18n="foot_cred">
            Por Un Mundo Mejor is a registered 501(c)(3) nonprofit organization.
          </p>
          <a
            class="credential-id"
            href="docs/tax-exempt-search.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <p class="credential-id" data-i18n="foot_ngo">
              NGO Registration No: 39-4366761
            </p>
          </a>

          <p class="footer-copy" data-i18n="foot_copy">
            &copy; Copyright 2026. All Rights Reserved.
          </p>
          <a href="policies.html" class="footer-link" data-i18n="foot_pol">Privacy & Policies</a>
        </div>

        <!-- Column 2: Direct Contact Channels -->
        <div class="footer-col contact-col">
          <h3 data-i18n="foot_contact">Contact Us</h3>
          <ul class="contact-list">
            <li>
              <a href="mailto:info@p1mm.org"
                ><i class="fas fa-envelope"></i> info@p1mm.org</a
              >
            </li>
            <li>
              <a href="tel:+1832-674-5331"
                ><i class="fas fa-phone"></i> +1 832-674-5331</a
              >
            </li>
            <li>
              <span class="location-text"
                ><i class="fas fa-map-marker-alt"></i> Houston, TX</span
              >
            </li>
          </ul>
        </div>

        <!-- Column 3: Social Connectivity -->
        <div class="footer-col socials-col">
          <h3 data-i18n="foot_follow">Follow Our Impact</h3>
          <div class="footer-socials">
            <a
              href="https://www.facebook.com/people/Por-Un-Mundo-Mejor/61589936751239/"
              target="_blank"
              rel="noopener"
              aria-label="Facebook"
              data-i18n-attr='{"aria-label":"fb"}'
            >
              <i class="fab fa-facebook-f"></i>
            </a>
            <!-- <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener"
              aria-label="Instagram"
            >
              <i class="fab fa-instagram"></i>
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener"
              aria-label="LinkedIn"
            >
              <i class="fab fa-linkedin-in"></i>
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener"
              aria-label="YouTube"
            >
              <i class="fab fa-youtube"></i>
            </a> -->
            <a
              href="https://tiktok.com/@por.un.mundo.mejo90"
              target="_blank"
              rel="noopener"
              aria-label="TikTok"
              data-i18n-attr='{"aria-label":"tk"}'
            >
              <i class="fab fa-tiktok"></i>
            </a>
          </div>
          <div>Version: 1.0.0</div>
        </div>
      </div>
    </footer>
        `;
  }
}

// Register the custom elements
customElements.define('custom-footer', CustomFooter);
